$(document).ready(function(){
  $('body').on('click', '.m_addToCartGrid', function(){
    $(this).parents('.gitem').find('.add-to-cart').trigger('click');
  });

    $('body').on('click', '.mChooseOptions', function(){
    $(this).parents('.gitem').find('.quickShop').trigger('click');
  });
  
 $('body').on('click', '.mQuickShopBtn', function(){
  const $btn = $(this);
  const $parent = $btn.parents('.gitem');

  setTimeout(function(){
    $parent.find('.closeShop').trigger('click');
  }, 500);
});

  
});

$(document).on('click', function (e) {
  const $drawer = $('.quickshopWrap:visible');

  if ($drawer.length && !$drawer.is(e.target) && $drawer.has(e.target).length === 0) {
    $drawer.find('.closeShop').trigger('click');
  }
});

// navigation search logic
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.brand-search').forEach(function (input) {
      input.addEventListener('input', function () {
        const search = input.value.trim().toLowerCase();
        const dropdown = input.closest('ul');
        if (!dropdown) return;

        dropdown.querySelectorAll('li.lvl-1').forEach(function (parentItem) {
          const subLinks = parentItem.querySelector('.subLinks');
          if (!subLinks) return;

          let hasMatch = false;

          subLinks.querySelectorAll('li.lvl-2').forEach(function (brandItem) {
            const brandName = brandItem.textContent.trim().toLowerCase();

            if (search === "") {
              // Input is cleared: show all items
              brandItem.style.display = '';
              hasMatch = true;
            } else {
              const match = brandName.includes(search);
              brandItem.style.display = match ? '' : 'none';
              if (match) hasMatch = true;
            }
          });

          if (search === "") {
            // Restore all parent items and subLinks to default visible state
            parentItem.style.display = '';
            subLinks.style.display = '';
          } else {
            parentItem.style.display = hasMatch ? 'list-item' : 'none';
            subLinks.style.display = hasMatch ? 'block' : 'none';
          }
        });
      });
    });
  });

//sticky atc spinnner

  document.addEventListener('DOMContentLoaded', function() {
  // Get all ATC buttons once when page loads
  const atcButtons = document.querySelectorAll('.add-to-cart-btn');
  
  atcButtons.forEach(button => {
    // Find spinner relative to each button
    const spinner = button.querySelector('.btn_spinner') || 
                   button.closest('form')?.querySelector('.btn_spinner');
    // Find the text element to hide/show
    const textElement = button.querySelector('.m-atc_txt');
    
    if (!spinner) return;
    
    button.addEventListener('click', function() {
      // Immediately show spinner and disable button
      button.setAttribute('aria-disabled', 'true');
      spinner.classList.remove('hidden');
      
      // Hide the text content
      if (textElement) {
        textElement.style.display = 'none';
      }
      
      // Set up cleanup handler
      const hideSpinner = () => {
        spinner.classList.add('hidden');
        button.removeAttribute('aria-disabled');
        
        // Show the text content again
        if (textElement) {
          textElement.style.display = 'block';
        }
      };
      
      // Handle form submission completion
      const form = button.closest('form');
      if (form) {
        form.addEventListener('ajax:complete', hideSpinner, { once: true });
        form.addEventListener('ajax:error', hideSpinner, { once: true });
        
        // Fallback timeout
        setTimeout(hideSpinner, 5000);
      } else {
        // If no form, just hide after reasonable delay
        setTimeout(hideSpinner, 1000);
      }
    });
  });
});